import React from "react"
import { Suspense } from "react"
import { Skeleton, Stack, Typography } from "@mui/material"
import { fetchDeviceReport, SupportReportQuery } from "../../supportApi"
import { useApiQuery } from "../../../../core/api/useApiQuery"
import {
    DeviceReportAlertAccordion,
    getSeverityIcon,
} from "../../../../shared/components/alert/DeviceReportAlertAccordion"
import { CardGroup } from "../../../merchant/merchant/home/components/CardGroup"
import { QueryErrorBoundary } from "../../../../core/api/components/QueryErrorBoundary"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()(() => ({
    merchant: {
        marginLeft: "1rem",
    },
    device: {
        marginLeft: "2rem",
    },
}))

export function DeviceReportContent() {
    const { classes } = useStyles()

    const { data: report } = useApiQuery(fetchDeviceReport, {
        queryName: SupportReportQuery.DEVICE_REPORT,
        dependencies: {},
        suspense: true,
        useErrorBoundary: true,
        refetchInterval: 30000,
    })

    if (!report || !report?.deviceReport) return null

    return (
        <CardGroup>
            <DeviceReportAlertAccordion
                status={report.deviceReport.state}
                title={report.deviceReport.title}
                message={report.deviceReport.message}
            >
                <Stack direction="column" spacing=".5rem">
                    {report.suppliers.map((supplier) => (
                        <React.Fragment key={supplier.id}>
                            <Typography variant="subtitle1">{supplier.name}</Typography>
                            {supplier.merchants.map((merchant) => (
                                <React.Fragment key={merchant.id}>
                                    <Typography variant="subtitle2" className={classes.merchant}>
                                        {merchant.name}
                                    </Typography>
                                    <Stack direction="column" spacing=".5rem" className={classes.device}>
                                        {merchant.devices.map((device) => (
                                            <Stack
                                                key={device.id}
                                                flexDirection="row"
                                                alignItems="center"
                                                spacing=".5rem"
                                            >
                                                {getSeverityIcon(device.status.state)}
                                                <Typography variant="body2">{device.status?.message ?? ""}</Typography>
                                            </Stack>
                                        ))}
                                    </Stack>
                                </React.Fragment>
                            ))}
                        </React.Fragment>
                    ))}
                </Stack>
            </DeviceReportAlertAccordion>
        </CardGroup>
    )
}

export function DeviceReport() {
    return (
        <QueryErrorBoundary>
            <Suspense fallback={<Skeleton variant="rectangular" animation="wave" width="100%" height="4.5rem" />}>
                <DeviceReportContent />
            </Suspense>
        </QueryErrorBoundary>
    )
}
